export default {
  'pc.requestFailed': '请求失败',
  'pc.login.title': '后台登录',
  'pc.login.usernamePlaceholder': '请输入用户名',
  'pc.login.passwordPlaceholder': '请输入密码',
  'pc.login.codePlaceholder': '请输入验证码',
  'pc.login.submit': '登录',
  'pc.login.usernameRequired': '请输入用户名',
  'pc.login.passwordRequired': '请输入密码',
  'pc.login.codeRequired': '请输入验证码',
  'pc.html.home': '首页',
  'pc.html.title': 'HTML管理',
  'pc.html.common': '公共',
  'pc.html.genHome': '生成首页HTML',
  'pc.html.genMenu': '生成全部菜单',
  'pc.html.article': '文章模块',
  'pc.html.genArticle': '生成文章和分类页面'
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh-CN/common.js